import type { ApiV1 } from '@teamworksdev/influencer/core';
import { isAuthenticated } from '@/stores/authStore';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser';

const LOG_PREFIX = '[CustomerIo]';

let cioAnalyticsInstance: AnalyticsBrowser | null = null;

const initCustomerIo = () => {
	if (!import.meta.env.MODE.startsWith('production')) return;

	if (cioAnalyticsInstance) return;

	const writeKey = import.meta.env.VITE_CUSTOMERIO_API_KEY;
	if (!writeKey) {
		console.warn(`${LOG_PREFIX} Write Key not configured`);
		return;
	}

	cioAnalyticsInstance = AnalyticsBrowser.load({ writeKey });
};

const identifyCustomerIo = (user: ApiV1.User, profile?: ApiV1.UserProfile) => {
	if (!isAuthenticated()) return;

	if (!cioAnalyticsInstance) {
		console.warn(`${LOG_PREFIX} Not initialized`);
		return;
	}

	const userId = profile?.axle.user_id ?? null;

	if (!userId) {
		console.warn(`${LOG_PREFIX} User ID not available`);
		return;
	}

	cioAnalyticsInstance.identify(userId, {
		email: user.email,
		first_name: user.first_name,
		last_name: user.last_name,
	});
};

const resetCustomerIo = () => {
	if (!cioAnalyticsInstance) return;
	cioAnalyticsInstance.reset();
};

export {
	initCustomerIo,
	identifyCustomerIo,
	resetCustomerIo,
};
